import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Conversations from '../../components/SubscriptionDetails/Conversations'
import BackButton from '../../components/UI/BackButton'
import Spinner from '../../components/UI/Spinner'
import { searchAPI } from '../../services/api/search'
import { PaginationContext } from '../../store/pagination-context'
import Pagination from '../Pagination/Pagination';
import styles from '../../styles/SubscriptionDetails.module.css'
import BucketFilters from '../Common/BucketFilters'
import DonutChart from '../Metrics/DonutChart'
import { conversationsChartsAPI } from '../../services/api/conversations-charts'
import { topDriversChartsAPI } from '../../services/api/top-drivers-chart'
import TopCallDrivers from '../Metrics/TopCallDrivers'
import { getCookie } from '../../utils/common'


const Main = () => {

    const {uuid} = useParams()

    const paginationCtx = useContext(PaginationContext)

    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState('')
    const [data, setData] = useState<{[key: string]: any}>({})

    const [isChartsLoading, setIsChartsLoading] = useState(true)

    const [emailCount, setEmailCount] = useState<number>(0)
    const [chatCount, setChatCount] = useState<number>(0)
    const [agents, setAgents] = useState<[]>([])

    const [isTopCallDriversLoading, setIsTopCallDriversLoading] = useState(true)
    const [topDriversData, setTopDriversData] = useState<any>({})
    

    useEffect(()=> {
        if(uuid) {
            getDetails()
            getConversationCount()
            getTopCallDrivers()
        }
    }, [uuid, paginationCtx.currentPage, paginationCtx.limit])

    const getDetails = () => {
        setError('')
        setIsLoading(true)

        const tenantSlug = getCookie('current_tenant')
        searchAPI(tenantSlug).getSingle?.(`${uuid}${paginationCtx.queryString}`)
        .then(response => {
            setData(response)
            setIsLoading(false)
            setAgents(response.unique_agent_count)
        })
        .catch(err => {
            setIsLoading(false)
            setError('Something went wrong. Please try again later.')
            console.log(err);
        })
    }

    const getConversationCount = () => {
        const tenantSlug = getCookie('current_tenant')
        conversationsChartsAPI(tenantSlug).getSingle?.(`1?search_subscription=${uuid}`)
        .then(response => {
            setIsChartsLoading(false)
            if(response?.communication_mode?.email) {
                setEmailCount(response.communication_mode.email)
            }
            if(response?.communication_mode?.chat) {
                setChatCount(response.communication_mode.chat)
            }
        })
        .catch(err => {
            setIsLoading(false)
            setError('Something went wrong. Please try again later.')
            console.log(err);
        })
    }

    const getTopCallDrivers = () => {
        const tenantSlug = getCookie('current_tenant')
        topDriversChartsAPI(tenantSlug).getSingle?.(`2?search_subscription=${uuid}`)
        .then(response => {
            setIsTopCallDriversLoading(false)
            setTopDriversData(response.chartData)
        })
        .catch(err => {
            setIsTopCallDriversLoading(false)
            console.log(err);
        })
    }

    return (
        <div className={`${styles.SubscriptionDetails} container bodyContainer`}>
            {
                isLoading && !data.name &&
                    <div className="d-flex justify-content-center my-5">
                        <Spinner size="md" />
                    </div>
            }
            {
                data.name && 
                    <>
                        <div className={`row ${styles.SubscriptionHeader}`}>
                            <div className="col-sm-6">
                                <div className="d-flex">
                                    <BackButton />
                                    <div>
                                        <h1 className="mb-4">{data.name}</h1>
                                        <BucketFilters 
                                            filters={data.filters} 
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 text-end">
                                <h2 className="mb-3">Total Filtered Conversations</h2>
                                <h3>{data.total_conversations} Conversations</h3>
                                <h3>{agents} Agents</h3>
                            </div>
                        </div>

                        {/* Graph */}
                        {
                            (!isChartsLoading && !isTopCallDriversLoading) &&
                            <div className={`bg-white d-flex ${styles.metricsContainer} p-2 mt-2`}>
                                <div className="col-sm-4 p-2">
                                    <DonutChart
                                        emails={emailCount}
                                        chats={chatCount}
                                    />
                                </div>    
                                <div className={`col-sm-8 p-2 ${styles.leftBorder}`}>
                                    <TopCallDrivers
                                        data={topDriversData}
                                    />
                                </div>                        
                            </div>
                        }
                        
                        <h4 className="mt-5 mb-3">All Conversations</h4>
                        <Pagination totalCount={data.total_conversations} />
                            {
                                !isLoading && data.conversations && data.conversations.length > 0 ?
                                <Conversations
                                    conversations={data.conversations}
                                    uuid={uuid}
                                    filters={data.filters}
                                /> :
                                <div className="d-flex justify-content-center my-5">
                                    <Spinner size="md" />
                                </div>
                            }
                        <Pagination totalCount={data.total_conversations} />
                    </>
            }
            {
                !isLoading && !data.conversations && !data.conversations.length && 
                    <div>{ error }</div>
            }
        </div>
    )
}

export default Main
